// extracted by extract-css-chunks-webpack-plugin
module.exports = {"HomePage":"HomePage__HomePage--cf7PV"};